import React from 'react'
import classNames from 'classnames'

export const Tag = ({ className, title, style, id }) => {
  return (
    <div
      className={classNames(
        'scrollbarHidden overflow-x-scroll rounded-[20px] px-xs py-[4px] font-noto-sans text-[11px] font-bold leading-[14.98px]',
        className
      )}
      {...{ style, id }}
    >
      {title}
    </div>
  )
}
